import { lazy, Suspense } from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import { PublicRoute, PrivateRoute } from './config';
import { isloggedIn } from 'helpers';
import Loader from 'components/loader';
import Layout from 'layout';
import Navigation from 'layout/navigation';

const Login = lazy(() => import('pages/auth/login'));
const Register = lazy(() => import('pages/auth/register'));
const Splash = lazy(() => import('pages/splash'));
const PageNotFound = lazy(() => import("pages/not-found"));
const Home = lazy(() => import('pages/home'));
const Plans = lazy(() => import('pages/plans'));
const MyMovements = lazy(() => import('pages/plans/my-movements'));
// plans - CreateMovement
const CreateMovement = lazy(() => import('pages/plans/my-movements/create-movement'));
//plan - exercise
const DefaultCoachPlans = lazy(() => import('pages/plans/default-plans'));
const NewPlan = lazy(() => import('pages/plans/default-plans/new-plan'));
const ShowPlan = lazy(() => import('pages/plans/default-plans/show-plan'));
// for exists plan
const ExercisePlan = lazy(() => import('pages/plans/exercise-plans'));
const SessionsPlan = lazy(() => import('pages/plans/exercise-plans/sessions'));
const DefineMovementPlan = lazy(() => import('pages/plans/exercise-plans/define-movement'));
// for add new plan data
const NewExerciseSessions = lazy(() => import('pages/plans/add-to-plan/exercise-plans'));
const AddSessionsPlan = lazy(() => import('pages/plans/add-to-plan/exercise-plans/sessions'));
const ShowNewPlan = lazy(() => import('pages/plans/default-plans/show-plan'));
const AddMovementPlan = lazy(() => import('pages/plans/add-to-plan/exercise-plans/define-movement'));
//plan - diet
const DietPlan = lazy(() => import('pages/plans/diet-plans/week-days'));
const DietDaysPlan = lazy(() => import('pages/plans/diet-plans/days'));
// add food plan
const AddDietPlan = lazy(() => import('pages/plans/add-to-plan/diet-plans/week-days'));
const AddDietDaysPlan = lazy(() => import('pages/plans/add-to-plan/diet-plans/days'));

// financial
const Financial = lazy(() => import('pages/financial'));
const MyTariffs = lazy(() => import('pages/financial/my-tariffs'));
const NewTariff = lazy(() => import('pages/financial/new-tariff'));
const EditTariff = lazy(() => import('pages/financial/new-tariff'));
// more 
const More = lazy(() => import('pages/more'));
const Profile = lazy(() => import('pages/more/profile'));
const EditProfile = lazy(() => import('pages/more/profile/edit-profile'));
const NoticesAndNews = lazy(() => import('pages/more/notices-and-news'));
const ShowNotices = lazy(() => import('pages/more/notices-and-news/show-notices'));
const Documents = lazy(() => import('pages/more/profile/documents'));
const AddDocument = lazy(() => import('pages/more/profile/documents/addDocument'));
const AboutUs = lazy(() => import('pages/more/about-us'));
const Books = lazy(() => import('pages/more/books'));
// movements
const Movements = lazy(() => import('pages/movements'));
const CategoriesMovements = lazy(() => import('pages/movements/cat-movements'));
const SeeMovement = lazy(() => import('pages/movements/see-movement'));
const Wallet = lazy(() => import('pages/financial/wallet'));
const Direct = lazy(() => import('pages/direct'));
const Chat = lazy(() => import('pages/direct/chat'));
const Request = lazy(() => import('pages/direct/request'));
const Info = lazy(() => import('pages/direct/request/info'));
const Analyze = lazy(() => import('pages/direct/request/analyze'));
const History = lazy(() => import('pages/direct/request/history'));
const Confirm = lazy(() => import('pages/direct/request/confirm'));
// presence
const Presence = lazy(() => import('pages/presence'));
const ManagePresence = lazy(() => import('pages/presence/manage-presence'));


function MainRouter({ socket }) {
    const isLogin = isloggedIn();
    return (
        <BrowserRouter>
            <Suspense fallback={<Loader />}>
                <Layout>
                    <Switch>
                        <PublicRoute isLogin={isLogin} restricted={true} path="/login" exact>
                            <Login />
                        </PublicRoute>
                        <PublicRoute isLogin={isLogin} restricted={true} path="/register" exact>
                            <Register />
                        </PublicRoute>
                        <PublicRoute isLogin={isLogin} restricted={false} path="/" exact>
                            <Splash />
                        </PublicRoute>
                        {/* direct */}
                        <PrivateRoute isLogin={isLogin} path="/direct/chat/:username/:room" exact>
                            <Chat socket={socket} />

                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/direct/request" exact>
                            <Request />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/direct/request/info" exact>
                            <Info />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/direct/request/body-analyze" exact>
                            <Analyze />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/direct/request/history" exact>
                            <History />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/direct/request/confirm-request" exact>
                            <Confirm />
                        </PrivateRoute>

                        {/*end exercise */}
                        <PrivateRoute isLogin={isLogin} path="/home" exact>
                            <Home />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/plans" exact>
                            <Plans />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/presence" exact>
                            <Presence />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/presence/:courseName/:courseId" exact>
                            <ManagePresence />
                        </PrivateRoute>
                        {/* exercise plans */}
                        <PrivateRoute isLogin={isLogin} path="/plans/defaults" exact>
                            <DefaultCoachPlans />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path={['/plans/defaults/show']} exact>
                            <ShowPlan />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path={"/plans/defaults/show/exercise/sessions"} exact>
                            <ExercisePlan />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path={"/plans/defaults/show/exercise/sessions/:sessionIndex"} exact>
                            <SessionsPlan />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin}
                            path={["/plans/defaults/show/exercise/sessions/:sessionIndex/:movementIndex",
                                "/plans/defaults/show/exercise/sessions/:sessionIndex/add"]} exact>
                            <DefineMovementPlan />
                            <Navigation />
                        </PrivateRoute>
                        {/* add new exercise plan */}
                        <PrivateRoute isLogin={isLogin} path="/plans/defaults/new-plan" exact>
                            <NewPlan />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path={"/plans/defaults/new-plan/show"} exact>
                            <ShowNewPlan />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path={"/plans/defaults/new-plan/show/exercise/sessions"} exact>
                            <NewExerciseSessions />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin}
                            path={["/plans/defaults/new-plan/show/exercise/sessions/:sessionIndex"]} exact>
                            <AddSessionsPlan />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin}
                            path={["/plans/defaults/new-plan/show/exercise/sessions/:sessionIndex/:movementIndex/:session",
                                "/plans/defaults/new-plan/show/exercise/sessions/:sessionIndex/:movementIndex"]} exact>
                            <AddMovementPlan />
                        </PrivateRoute>
                        {/* addd new food plan routing */}
                        <PrivateRoute isLogin={isLogin} path={"/plans/defaults/new-plan/show/food"} exact>
                            <AddDietPlan />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path={["/plans/defaults/new-plan/show/food/days/:dayIndex",
                            "/plans/defaults/new-plan/show/food/days"]}>
                            <AddDietDaysPlan />
                        </PrivateRoute>
                        {/* show default food plans */}
                        <PrivateRoute isLogin={isLogin} path={"/plans/defaults/show/food"} exact>
                            <DietPlan />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path={["/plans/defaults/show/food/days",
                            "/plans/defaults/show/food/days/:dayIndex"]} exact>
                            <DietDaysPlan />
                        </PrivateRoute>
                        {/* direct */}
                        <PrivateRoute isLogin={isLogin} path={["/direct", "/direct/:tabIndex"]} exact>
                            <Navigation>
                                <Direct socket={socket} />
                            </Navigation>
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/my-movements" exact>
                            <MyMovements />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path={["/my-movements/create-movement", "/my-movements/:motionId"]} exact>
                            <CreateMovement />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/financial" exact>
                            <Financial />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/financial/my-tariffs" exact>
                            <MyTariffs />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/financial/new-tariff" exact>
                            <NewTariff />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/financial/tariff/:id" exact>
                            <EditTariff />
                            <Navigation />
                        </PrivateRoute>
                        {/* --- More --- */}
                        <PrivateRoute isLogin={isLogin} path="/more" exact>
                            <More />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/more/books" exact>
                            <Books />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/more/profile" exact>
                            <Profile />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/more/profile/edit" exact>
                            <EditProfile />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/more/about-us" exact>
                            <AboutUs />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/more/notices-and-news" exact>
                            <NoticesAndNews />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin}
                            path={['/more/notices-and-news/:news/:id',
                                '/more/notices-and-news/:notif/:id']} exact>
                            <ShowNotices />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/more/profile/documents" exact>
                            <Documents />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path={["/more/profile/documents/add", "/more/profile/documents/:id"]} exact>
                            <AddDocument />
                            <Navigation />
                        </PrivateRoute>
                        {/* --- Movements --- */}
                        <PrivateRoute isLogin={isLogin} path="/movements" exact>
                            <Movements />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/movements/:id" exact>
                            <CategoriesMovements />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/movements/:id/:motion_id" exact>
                            <SeeMovement />
                            <Navigation />
                        </PrivateRoute>
                        <PrivateRoute isLogin={isLogin} path="/financial/wallet" exact>
                            <Wallet />
                            <Navigation />
                        </PrivateRoute>
                        <PublicRoute isLogin={isLogin}>
                            <PageNotFound />
                        </PublicRoute>
                    </Switch>
                </Layout>
            </Suspense>
        </BrowserRouter >
    );
}
export default MainRouter;
